import { Navigate, Outlet } from "react-router";
import { useAuth } from "../context/auth";

export function RequireAuth() {
	const { user, loading } = useAuth();

	if (loading) return null;
	if (!user) return <Navigate to="/sign-in" replace />;
	return <Outlet />;
}
